import React, {CSSProperties, useEffect, useState} from "react";
import {Dialog} from "@components/interface/Dialog";
import {Tabs} from "@components/interface/Tabs";
import {TabsPanel} from "@components/interface/TabsPanel";
import {ScoresTabPanel} from "@components/dialog/score/ScoresTabPanel";
import {Game, IGlobalScore, IWordScore} from "@game/game";
import {selectDialog} from "@redux/selectors/dialog";
import {connect} from "react-redux";
import {IDialog, update as updateDialog} from "@redux/slices/dialog";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {THEME} from "@components/core/theme";
import {Update} from "@redux/slices/base";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    bottomBar: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 8
    },
    button: {
        fontSize: "large",
        margin: 2,
        padding: 4
    },
}
const details: Record<string, ILeaderboardDetails> = {
    daily: {
        title: "ScoresTabDaily",
        total: "totalDaily",
        word: "wordDaily"
    },
    monthly: {
        title: "ScoresTabMonthly",
        total: "totalMonthly",
        word: "wordMonthly"
    },
    weekly: {
        title: "ScoresTabWeekly",
        total: "totalWeekly",
        word: "wordWeekly"
    }
};
const initialTab = "ScoresTabDaily";

interface ILeaderboardDetails {
    title: string
    total: string
    word: string
}
interface IPlayerScore {
    count: number
    sum: number
}
interface IScoreDialog {
    dialog: IDialog
    game: Game
    updateDialog: Update
}
function ScoreDialog({dialog, game, updateDialog}: IScoreDialog) {
    const [globalHighScores, setGlobalHighScores] =
        useState<Record<string, IGlobalScore[]>>({});
    const [globalLeaderboards, setGlobalLeaderboards] =
        useState<Record<string, IWordScore[]>>({});
    const [playerLeaderboards, setPlayerLeaderboards] =
        useState<Record<string, IWordScore[]>>({});
    const [playerScores, setPlayerScores] =
        useState<Record<string, IPlayerScore>>({});
    const handleLoginClick = () => {
        updateDialog({update: {name: "authenticate"}})
    }

    useEffect(() => {
        if (dialog.name === "score") {
            game.getUserPlayerLeaderboards().then(update => setPlayerLeaderboards(update));
            game.getUserGlobalHighScores().then(update => setGlobalHighScores(update));
            game.getUserGlobalLeaderboards().then(update => setGlobalLeaderboards(update));
            game.getUserScores().then(update => setPlayerScores(update));
        }
    }, [dialog.name, game]);
    if (dialog.name !== "score" || Object.keys(playerLeaderboards).length === 0 ||
        Object.keys(globalLeaderboards).length === 0) return null;
    return (
        <Dialog close={true} title="ScoresMenuTitle" subtitle="Best ten scores are listed, totaled and averaged in each category.">
            <Tabs initial={initialTab}>
                {Object.keys(playerLeaderboards).map(type =>
                    <TabsPanel key={type} label={details[type].title}>
                        <ScoresTabPanel game={game} globalScores={globalHighScores[type] || []}
                                        globalLeaderboards={globalLeaderboards[type] || []}
                                        playerLeaderboards={playerLeaderboards[type] || []}
                                        playerTotalScore={playerScores[details[type].total]}
                                        playerWordScore={playerScores[details[type].word]}/>
                    </TabsPanel>
                )}
            </Tabs>
            <div style={styles.bottomBar}>
                {game.userPlayer?.anonymous && <button onClick={handleLoginClick} style={styles.button}>
                    <LocalisedTypography content="ButtonLoginForHighScores"/>
                </button>}
            </div>
        </Dialog>
    );
}

const mapStateToProps = (store: never) => ({
    dialog: selectDialog(store)
});
const connected = connect(mapStateToProps, {
    updateDialog
})(ScoreDialog);
export {connected as ScoreDialog}
